"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayConfigurationV2 = exports.GatewayConfiguration = exports.ConfigurationProvider = void 0;
const tslib_1 = require("tslib");
const uuid_1 = require("uuid");
const global_object_1 = tslib_1.__importDefault(require("./global-object"));
class ConfigurationProvider {
    constructor(options) {
        if (!options.url) {
            throw new Error('The parameter "url" is required.');
        }
        if (options.url.endsWith('/')) {
            options.url = options.url.substr(0, options.url.length - 1);
        }
        this.url = options.url;
        this.jwtToken = options.jwtToken;
        this.refreshTokenId = options.refreshTokenId;
        this.logger = options.logger || { log: () => { }, error: () => { } };
        this.requestIdProvider = options.requestIdProvider || (() => (0, uuid_1.v4)());
        this.requestFromProvider = options.requestFromProvider || (() => 'unknown');
        this.requestFromVersionProvider = options.requestFromVersionProvider || (() => 'unknown');
        this.requestTagsProvider = options.requestTagsProvider || (() => ({}));
    }
    setRefreshedToken(token) {
        this.jwtToken = token;
    }
}
exports.ConfigurationProvider = ConfigurationProvider;
class GatewayConfiguration extends ConfigurationProvider {
    constructor(url, jwtToken, refreshTokenId, logger, requestIdProvider, requestFromProvider, requestTagsProvider) {
        super({ url, jwtToken, refreshTokenId, logger, requestIdProvider, requestFromProvider, requestTagsProvider });
    }
    get token() {
        if (!this.jwtToken) {
            return undefined;
        }
        return { jwtToken: this.jwtToken, refreshTokenId: this.refreshTokenId };
    }
    getHeaders() {
        var _a, _b, _c, _d;
        const ret = {
            ['x-request-id']: (_a = this.requestIdProvider()) !== null && _a !== void 0 ? _a : (0, uuid_1.v4)(),
            ['x-request-from']: (_b = this.requestFromProvider()) !== null && _b !== void 0 ? _b : 'unknown',
            ['x-request-from-version']: (_c = this.requestIdProvider()) !== null && _c !== void 0 ? _c : 'unknown',
            ['x-request-tags']: serializeTags((_d = this.requestTagsProvider()) !== null && _d !== void 0 ? _d : null),
        };
        return ret;
    }
    onRequest(_) { }
    onResponse(_) { }
    getConfiguration() {
        return this;
    }
}
exports.GatewayConfiguration = GatewayConfiguration;
function serializeTags(tags) {
    if (!tags) {
        return '';
    }
    return Object.entries(tags)
        .map((entry) => {
        const [key, value] = entry;
        const encodedValue = global_object_1.default.encodeURIComponent(value);
        return `${key}=${encodedValue}`;
    })
        .join(',');
}
class GatewayConfigurationV2 extends ConfigurationProvider {
    constructor(options) {
        super(options);
    }
    getConfiguration() {
        return this;
    }
}
exports.GatewayConfigurationV2 = GatewayConfigurationV2;
//# sourceMappingURL=gateway.configuration.js.map